import $ from 'jquery';
import * as globalUtils from '../../Global/global_js';
import * as indexFunctionUtils from '../index_functions';
import * as Index2Utils from '../js/index2';
import * as timeago from 'timeago.js';
var get_comments_type = "first_20";
var first_comment_datetime = "";
var last_comment_datetime = "";
var video_guid = "";
var video_type = "";
var dv_account_guid = "";

//var error_info = localStorage.getItem("error_info");
////////////////////////////////////////////////////////// start update video comments 
// load top 20 comments 
// this function loads every 30 secs to get the latest comments
export function update_shown_comments(t)
{
    try
    {
        video_guid = t.state.videoData.videoGuid;
        video_type = t.state.videoData.videoType;
        dv_account_guid = t.state.videoData.userGuid;


        // first i will get latest 20 videos
        if (first_comment_datetime == "")
        {
            get_comments_type = "first_20";
            get_video_comments(t);
        }
       else
        {
            var api_link = localStorage.getItem("api_url") + "get_newest_comments_by_video_guid";
            var parameters =
            {
                video_guid: video_guid,
                video_type: video_type,
                comment_datetime: first_comment_datetime,
                account_guid: dv_account_guid,
                error_info: "account_guid=" + dv_account_guid + "&video_guid=" + video_guid
            };
            $.ajax({
                type: "POST",
                url: api_link,
                data: parameters,
                async: true,
                dataType: "json",
                success: function (response) { update_shown_comments_success(t, response) },
                error: update_shown_comments_error
            });
        }
    }
    catch (ex)
    {
        globalUtils.send_error_fun("video_comments.js",
            "update_shown_comments",
            ex, "account_guid=" + dv_account_guid + "&video_guid=" + video_guid);
    }
}
function update_shown_comments_success(t, response)
{
    try
    {
        if (response)
        {
            if (response.length > 0) {
                // change first comment date
                if (response[0]) {
                    first_comment_datetime = response[0].comment_datetime;
                    var all_comments = t.state.videoData.video_comments;
                    var user_image_path = "";
                    var can_edit_delete = false;
                    for (var i = 0; i < response.length; i++) {
                        can_edit_delete = false;
                        var comment_date = globalUtils.convert_datetime_from_UTC(response[i].comment_datetime);
                        user_image_path = localStorage.getItem("get_image_server_url") + "accounts_media/images/" + response[i].account_guid + "/" + response[0].image_name;
                        var google_account_info = globalUtils.getCookie("google_Acount_info");
                        if (google_account_info === null) {
                            var helnix_cookie = globalUtils.getCookie("helnix_cookies");
                            if (helnix_cookie !== null && helnix_cookie !== undefined) {
                                helnix_cookie = globalUtils.convertHelnixCookieToObject(helnix_cookie);
                                google_account_info = helnix_cookie;
                                t.setState({ google_account_info: google_account_info });
                            }
                        }
                        else {
                            google_account_info = JSON.parse(google_account_info);
                        }
                        if (response[i].user_firstname === "") {

                            response[i].user_firstname = response[i].google_user_first_name;
                            response[i].user_lastname = response[i].google_user_last_name;
                        }

                        if ((dv_account_guid === response[i].account_guid) || (google_account_info !== null && google_account_info.email === response[i].account_guid)) {
                            can_edit_delete = true;
                        }
                        all_comments.unshift({
                            user_name: response[i].user_firstname + " " + response[i].user_lastname, comment: response[i].comment,
                            date: timeago.format(comment_date),
                            user_image: user_image_path,
                            can_edit_delete: can_edit_delete,
                            comment_guid: response[i].comment_guid,
                            showEditInput: false,
                        })
                    }
                    var show_more_comments = response[0].comments_number > all_comments.length ? true : false;
                    t.setState(prevState => ({
                        videoData: {
                            ...prevState.videoData,
                            video_comments: all_comments,
                            comments_count: response[0].comments_number,
                            show_more_comments: show_more_comments,
                        }
                    }))
                }
            }
        }
    }
    catch (ex)
    {
        globalUtils.send_error_fun("video_comments.js",
            "update_shown_comments_success",
            ex, "account_guid=" + dv_account_guid + "&video_guid=" + video_guid);
    }
}
function update_shown_comments_error(ex)
{
    globalUtils.send_error_fun("video_comments.js",
        "update_shown_comments_error",
        ex, "account_guid=" + dv_account_guid + "&video_guid=" + video_guid);
}


///////////////////////////////////////////////////////////////////////////////////////// end update video comments 
// load comments for video
export function get_video_comments(t)
{
    try
    {
        if (localStorage.getItem("api_url"))
        {
            video_guid = t.state.videoData.videoGuid;
            video_type = t.state.videoData.videoType;
            dv_account_guid = t.state.videoData.userGuid;

            var api_link = localStorage.getItem("api_url") + "get_comments_by_video_guid";
            var parameters =
            {
                video_guid: video_guid,
                video_type: video_type,
                type: get_comments_type,
                comment_datetime: last_comment_datetime,
                account_guid: dv_account_guid,
                error_info: "account_guid=" + dv_account_guid + "&video_guid=" + video_guid +
                    "&api_link=" + localStorage.getItem("api_url") + "get_comments_by_video_guid"
            };

            $.ajax({
                type: "POST",
                url: api_link,
                data: parameters,
                async: false,
                dataType: "json",
                success: function (response)
                {
                    get_video_comments_success(t, response)
                },
                error: get_video_comments_error
            });
        }
        else
        {
            globalUtils.get_api_url(t);
        }
    }
    catch (ex)
    {
        
        globalUtils.send_error_fun("video_comments.js",
            "get_video_comments",
            ex, "account_guid=" + dv_account_guid + "&video_guid=" + video_guid);
    }
}

// load comments on design
function get_video_comments_success(t, response)
{
    try
    {
        if (response != null && response.length > 0)
        {
            var all_comments = [];
            if (get_comments_type === "check_datetime")
            {
                all_comments = t.state.videoData.video_comments;
            }
            var time_ago = "";
            var user_image_path = "";
            var can_edit_delete = false;
            
            for (var i = 0; i < response.length; i++)
            {
                can_edit_delete = false;
                var comment_date = globalUtils.convert_datetime_from_UTC(response[i].comment_datetime);
                user_image_path = localStorage.getItem("get_image_server_url") + "accounts_media/images/" + response[i].account_guid + "/" + response[0].image_name;

                var google_account_info = globalUtils.getCookie("google_Acount_info"); //t.state.google_account_info;
                if (google_account_info === null)
                {
                    var helnix_cookie = globalUtils.getCookie("helnix_cookies");
                    if (helnix_cookie !== null && helnix_cookie !== undefined)
                    {
                        helnix_cookie = globalUtils.convertHelnixCookieToObject(helnix_cookie);
                        google_account_info = helnix_cookie;
                        t.setState({ google_account_info: google_account_info })
                    }
                }
                else
                {
                    google_account_info = JSON.parse(google_account_info);
                }
                if (response[i].user_firstname === "")
                {
                    response[i].user_firstname = response[i].google_user_first_name;
                    response[i].user_lastname = response[i].google_user_last_name;
                }

                if ((dv_account_guid === response[i].account_guid) || (google_account_info !== null && google_account_info.email === response[i].account_guid))
                {
                    can_edit_delete = true;
                }

                all_comments.push({
                    user_name: response[i].user_firstname + " " + response[i].user_lastname, comment: response[i].comment,
                    date: timeago.format(comment_date),
                    user_image: user_image_path,
                    can_edit_delete: can_edit_delete,
                    comment_guid: response[i].comment_guid,
                    showEditInput: false,
                })
            }
            var show_more_comments = parseInt(response[0].comments_number) > all_comments.length ? true : false;
            t.setState(prevState => ({
                videoData: {
                    ...prevState.videoData,
                    video_comments: all_comments,
                    comments_count: response[0].comments_number,
                    show_more_comments: show_more_comments
                }
            }))


            // save latest comment date
            last_comment_datetime = response[response.length - 1].comment_datetime;

            if (get_comments_type == "first_20")
            {
                // get first row date time
                first_comment_datetime = response[0].comment_datetime;
            }
        }

    }
    catch (ex)
    {
        
        globalUtils.send_error_fun("video_comments.js",
            "get_video_comments_success",
            ex, "account_guid=" + dv_account_guid + "&video_guid=" + video_guid);
    }
}

function get_video_comments_error(ex)
{
    var browser = Index2Utils.get_browser_name();
    globalUtils.send_error_fun("video_comments.js",
        "get_video_comments_error",
        ex, "account_guid=" + dv_account_guid + "&video_guid=" + video_guid + "&browser=" + browser +
        "&api_link=" + localStorage.getItem("api_url") + "get_comments_by_video_guid");

    //$('#comments_number').text("Please try again.");
    //send_error_fun("video_comments.js",
    //    arguments.callee.toString().match(/function ([^\(]+)/)[1],
    //    ex, error_info + "&video_guid=" + video_guid);
}
///////////////////////////////////////////////////////////////////////////////////////// end get more video comments

export function add_new_comment(t, keyCode, shiftKey)
{
    try
    {
        // if key pressed is only enter and not shift enter 
        if (keyCode == 13 && !shiftKey)
        {
            var google_account_info = JSON.parse(localStorage.getItem("google_account_info"));
            // user must be signed in
            var helnix_cookie = globalUtils.getCookie("helnix_cookies");
            console.log("helnix_cookies = ", helnix_cookie);

            if (helnix_cookie !== null && helnix_cookie !== undefined)
            {
                helnix_cookie = indexFunctionUtils.convertHelnixCookieToObject(helnix_cookie);
                dv_account_guid = helnix_cookie.account_guid;
            }
            else if (google_account_info !== null && google_account_info !== undefined)
            {
                dv_account_guid = google_account_info.email;
            }
            if (dv_account_guid == null || dv_account_guid == "" || dv_account_guid == undefined)
            {
                var account_url = "";
                if (t.state.google_account_info !== null)
                {
                    var comment_text = t.state.comment_text.replace(/</g, '&lt;').trim().replace(/>/g, '&gt;').replace(/\n/g, "<br />");

                    if (comment_text != "")
                    {
                        // call api to add new comment
                        var api_link = localStorage.getItem("api_url")+ "add_comment_with_google_login";
                        var parameters =
                        {
                            video_guid: video_guid,
                            video_type: video_type,
                            account_guid: t.state.google_account_info.email,
                            google_user_first_name: t.state.google_account_info.first_name,
                            google_user_last_name: t.state.google_account_info.last_name,
                            comment: comment_text,
                            comment_is_valid: 'true',
                            error_info: "account_guid=" + dv_account_guid + "&video_guid=" + video_guid
                        };

                        $.ajax({
                            type: "POST",
                            url: api_link,
                            data: parameters,
                            async: true,
                            dataType: "json",
                            success: function (response)
                            { add_new_comment_success(t, response) },
                            error: function (response)
                            { add_new_comment_error(t, response); }
                        });
                    }
                    else
                    {
                        t.showToast("Please write a comment", "error");
                    }
                }
                else
                {
                    t.setState({
                        showLoginCustomAlert: true,
                    })
                }

            }
            else
            {
                // replace new line with br tag and replace html tags with html code
                var comment_text = t.state.comment_text.replace(/</g, '&lt;').trim().replace(/>/g, '&gt;').replace(/\n/g, "<br />");

                if (comment_text != "")
                {
                    // call api to add new comment
                    var api_link = localStorage.getItem("api_url") + "add_comment_with_google_login";
                    var parameters =
                    {
                        video_guid: video_guid,
                        video_type: video_type,
                        account_guid: dv_account_guid,
                        comment: comment_text,
                        comment_is_valid: 'true',
                        error_info: "account_guid=" + dv_account_guid + "&video_guid=" + video_guid
                    };

                    $.ajax({
                        type: "POST",
                        url: api_link,
                        data: parameters,
                        async: true,
                        dataType: "json",
                        success: function (response)
                        { add_new_comment_success(t, response) },
                        error: function (response)
                        { add_new_comment_error(t, response); }
                    });
                }
                else
                {
                    t.showToast("Please write a comment", "error");
                }
            }
        }
    }
    catch (ex)
    {
        t.showToast("Error occured please contact admin", "error");
        globalUtils.send_error_fun("video_comments.js",
            "add_new_comment",
            ex, "account_guid=" + dv_account_guid + "&video_guid=" + video_guid);
    }
}

// load aded comment in design
function add_new_comment_success(t, response)
{
    try
    {

        if (response == true)
        {
            update_shown_comments(t);
            t.setState({ comment_text: "", }, () =>
            {
                t.commentsPart.clearComment();

            })
        }
        else
        {
            t.showToast("Error occured please contact admin", "error");
        }
    }
    catch (ex)
    {
        t.showToast("Error occured please contact admin", "error");
        globalUtils.send_error_fun("video_comments.js",
            "add_new_comment_success",
            ex, "account_guid=" + dv_account_guid + "&video_guid=" + video_guid);
    }
}
function add_new_comment_error(t, ex)
{
    t.showToast("Error occured please contact admin", "error");
    globalUtils.send_error_fun("video_comments.js",
        "add_new_comment_error",
        ex, "account_guid=" + dv_account_guid + "&video_guid=" + video_guid);
}
export function load_more_comments(t)
{
    get_comments_type = "check_datetime";
    get_video_comments(t);
}
export function delete_comment(t, comment_guid)
{
    try
    {
        var api_link = localStorage.getItem("api_url") + "delete_comment_by_comment_guid";
        var parameters =
        {
            comment_guid: comment_guid,
            account_guid: dv_account_guid,
            video_guid: video_guid,
            error_info: "account_guid=" + dv_account_guid + "&comment_guid=" + comment_guid
        };

        $.ajax({
            type: "POST",
            url: api_link,
            data: parameters,
            async: false,
            dataType: "json",
            success: function (response)
            { delete_comment_success(t, response, comment_guid) },
            error: function (response)
            {
                delete_comment_error(t, response, comment_guid);
            }
        });
    }
    catch (ex)
    {
        t.showToast("Error occured please contact admin", "error");
        globalUtils.send_error_fun("video_comments.js",
            "delete_comment",
            ex, "account_guid=" + dv_account_guid + "&comment_guid=" + comment_guid);
    }
}
function delete_comment_success(t, response, comment_guid)
{
    try
    {
        if (response == true)
        {
            var all_comments = t.state.videoData.video_comments;
            var comments_count = t.state.videoData.comments_count;
            var new_comments = [];
            for (var i = 0; i < all_comments.length; i++)
            {
                if (all_comments[i].comment_guid !== t.state.comment_guid_to_delete)
                {
                    new_comments.push(all_comments[i]);
                }
            }
            t.setState(prevState => ({
                videoData: {
                    ...prevState.videoData,
                    video_comments: new_comments,
                    comments_count: comments_count - 1,
                },
                showCustomAlert: false, comment_guid_to_delete: ""
            }))
        }
        else
        {
            t.showToast("Error occured please contact admin", "error");
        }
    }
    catch (ex)
    {
        t.showToast("Error occured please contact admin", "error");
        globalUtils.send_error_fun("video_comments.js",
            "delete_comment_success",
            ex, "account_guid=" + dv_account_guid + "&comment_guid=" + comment_guid);
    }
}
function delete_comment_error(t, ex, comment_guid)
{
    t.showToast("Error occured please contact admin", "error");
    globalUtils.send_error_fun("video_comments.js",
        "delete_comment_error",
        ex, "account_guid=" + dv_account_guid + "&comment_guid=" + comment_guid);
}
export function save_edit_comment(t, item)
{
    try
    {
        // get guid from id 
        var current_guid = item.comment_guid;
        var comment_guid_for_edit = current_guid;
        var edit_comment_text = item.comment.replace(/</g, '&lt;').trim().replace(/>/g, '&gt;').replace(/\n/g, "<br />");
        if (edit_comment_text != "")
        {

            // call api to add new comment
            var api_link = localStorage.getItem("api_url") + "edit_comment_by_comment_guid";
            var parameters =
            {
                comment: edit_comment_text,
                comment_guid: comment_guid_for_edit,
                account_guid: dv_account_guid,
                video_guid: video_guid,
                error_info: "account_guid=" + dv_account_guid + "&comment_guid=" + comment_guid_for_edit
            };

            $.ajax({
                type: "POST",
                url: api_link,
                data: parameters,
                async: false,
                dataType: "json",
                success: function (response)
                { edit_comment_success(t, item, response) },
                error: function (response)
                {
                    edit_comment_error(t, response, item)
                }
            });
        }
    }
    catch (ex)
    {
        globalUtils.send_error_fun("video_comments.js",
            "save_edit_comment",
            ex, "account_guid=" + dv_account_guid + "&comment_guid=" + item.comment_guid);
        //send_error_fun("video_comments.js",
        //    arguments.callee.toString().match(/function ([^\(]+)/)[1],
        //    ex, error_info + "&comment_guid=" + comment_guid_for_edit);
    }
}
function edit_comment_success(t, item, response)
{
    try
    {
        if (response == true)
        {
            t.cancelCommentChange(item, true);
        }
        else
        {
            t.cancelCommentChange(item, false)
        }
    }
    catch (ex)
    {
        t.showToast("Error occured please contact admin", "error");
        globalUtils.send_error_fun("video_comments.js",
            "edit_comment_success",
            ex, "account_guid=" + dv_account_guid + "&comment_guid=" + item.comment_guid);
        //send_error_fun("video_comments.js",
        //    arguments.callee.toString().match(/function ([^\(]+)/)[1],
        //    ex, error_info + "&comment_guid=" + comment_guid_for_edit);
    }
}
function edit_comment_error(t, ex,item)
{
    t.showToast("Error occured please contact admin", "error");
    globalUtils.send_error_fun("video_comments.js",
        "edit_comment_error",
        ex, "account_guid=" + dv_account_guid + "&comment_guid=" + item.comment_guid);
   
}